import { render, staticRenderFns } from "./show-info-module.vue?vue&type=template&id=4baad535&scoped=true&"
import script from "./show-info-module.vue?vue&type=script&lang=js&"
export * from "./show-info-module.vue?vue&type=script&lang=js&"
import style0 from "./show-info-module.vue?vue&type=style&index=0&id=4baad535&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4baad535",
  null
  
)

component.options.__file = "show-info-module.vue"
export default component.exports